import { useState } from "react";
import { Mail, X } from "lucide-react";

const StickyMailboxButton = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="fixed bottom-24 right-6 z-[9980] flex items-center gap-1" data-testid="sticky-mailbox-btn">
      <button onClick={() => setDismissed(true)} className="w-5 h-5 bg-neutral-800 text-neutral-400 hover:text-white rounded-full flex items-center justify-center text-[10px] transition-colors" aria-label="Dismiss">
        <X className="w-3 h-3" />
      </button>
      <a
        href="https://mybizconsultingllc.anytimemailbox.com/signup"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 bg-[#333333] hover:bg-[#444444] text-white px-4 py-2.5 rounded-full shadow-lg border border-[#39FF14]/30 transition-all hover:shadow-xl hover:border-[#39FF14]/60 group"
      >
        <Mail className="w-4 h-4 text-[#39FF14] group-hover:scale-110 transition-transform" />
        <span className="text-xs font-medium whitespace-nowrap">Get Your Virtual Mailbox</span>
      </a>
    </div>
  );
};

export default StickyMailboxButton;
